import MenuItem from "components/Editorial/ActionsMenu/MenuItem";
import React from "react";
import ReactMenuItem from "components/Editorial/ActionsMenu/ReactMenuItem";

export default class MenuItemComponent {
  /**
   * @param {ReactMenuItemType, MenuItemType} item
   */
  static for(item) {
    return item.react ?
      <ReactMenuItem key={item.props} item={item} /> :
      <MenuItem key={item.url} item={item} />;
  }
}
